import { useMemo } from 'react'

import {
  DeleteAITrainingMaterialMutation,
  DeleteAITrainingMaterialMutationVariables,
  GetAllAITrainingMaterialsQuery,
  GetAllAITrainingMaterialsQueryVariables,
  RetryAITrainingMaterialMutation,
  RetryAITrainingMaterialMutationVariables,
  UploadAITrainingMaterialFilesMutation,
  UploadAITrainingMaterialFilesMutationVariables,
} from 'types/graphql'
import { AIVectorStoreType } from 'types/graphql'

import { useActiveOrgId } from 'src/hooks/use-active-org-id'
import { QueryKey, useMutation, useQuery } from 'src/utils/queryClient'

const GetAll = gql`
  query GetAllAITrainingMaterialsQuery($vectorStoreType: AIVectorStoreType!, $organizationId: Int) {
    getAllAITrainingMaterials(vectorStoreType: $vectorStoreType, organizationId: $organizationId) {
      ...AITrainingMaterialFragment
    }
  }
`
export const useGetAllAITrainingMaterialsQuery = (vectorStoreType: AIVectorStoreType) => {
  const organizationId = useActiveOrgId()
  const { data, ...rest } = useQuery<
    GetAllAITrainingMaterialsQuery,
    GetAllAITrainingMaterialsQueryVariables
  >({
    queryKey: [QueryKey.GetAllAITrainingMaterials, organizationId],
    queryDocument: GetAll,
    variables: { vectorStoreType, organizationId },
    enabled: !!organizationId,
  })
  const materials = useMemo(() => data?.getAllAITrainingMaterials || [], [data])
  return { ...rest, materials }
}

const Upload = gql`
  mutation UploadAITrainingMaterialFilesMutation($input: UploadAITrainingMaterialFilesInput!) {
    uploadAITrainingMaterialFiles(input: $input) {
      ...AITrainingMaterialFragment
    }
  }
`
export const useUploadAITrainingMaterialFilesMutation = () => {
  return useMutation<
    UploadAITrainingMaterialFilesMutation,
    UploadAITrainingMaterialFilesMutationVariables
  >({
    mutationDocument: Upload,
  })
}

const Delete = gql`
  mutation DeleteAITrainingMaterialMutation($id: Int!) {
    deleteAITrainingMaterial(id: $id) {
      id
    }
  }
`
export const useDeleteAITrainingMaterialMutation = () => {
  return useMutation<DeleteAITrainingMaterialMutation, DeleteAITrainingMaterialMutationVariables>({
    mutationDocument: Delete,
  })
}

const Retry = gql`
  mutation RetryAITrainingMaterialMutation($id: Int!) {
    retryAITrainingMaterial(id: $id) {
      ...AITrainingMaterialFragment
    }
  }
`
export const useRetryAITrainingMaterialMutation = () => {
  return useMutation<RetryAITrainingMaterialMutation, RetryAITrainingMaterialMutationVariables>({
    mutationDocument: Retry,
  })
}
